// #region Imports

// #endregion Imports

export class ApiServiceBase {
    protected get(url: string, onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        return this.ajax(url, 'GET', onSuccess, onFailure);
    }

    protected post(url: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, data?: any): JQuery.jqXHR {
        return this.ajax(url, 'POST', onSuccess, onFailure, data);
    }

    protected postJson(url: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, data?: any): JQuery.jqXHR {
        return this.ajax(url, 'POST', onSuccess, onFailure, data, true);
    }

    protected put(url: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, data?: any): JQuery.jqXHR {
        return this.ajax(url, 'PUT', onSuccess, onFailure, data);
    }

    protected delete(url: string, onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        return this.ajax(url, 'DELETE', onSuccess, onFailure);
    }

    private ajax(url: string, method: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, data?: any, isJson?: boolean): JQuery.jqXHR {
        let options: any = {
            url: url,
            method: method
        };

        if (isJson) {
            options = {
                ...options,
                contentType: 'application/json; charset=utf-8'
            }

            data = JSON.stringify(data);
        }

        if (data) {
            options = {
                data: data,
                ...options
            };
        }

        return $.ajax(options).done(onSuccess).fail(onFailure);
    }
}